<template>
  <svg
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.29044 0L2.21208 6.79637V10.2663H3.70265V7.79032H9.37612V1.44925H21.2932V10.2665H22.786V0.000575296L8.29044 0Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.70262 20.8527H21.2935V25.5505L3.70262 25.5338V20.8527ZM15.4271 13.2598H20.2441V14.2627H18.4516V19.0087L17.2104 19.0086V14.2626H15.4272L15.4271 13.2598ZM10.1767 13.2598H12.7895C13.8455 13.2598 14.6892 14.0386 14.6892 15.119C14.6892 16.1559 13.9022 16.921 12.7895 16.921H11.4153V19.009H10.1768L10.1767 13.2598ZM4.75633 13.2598H7.36922C8.42518 13.2598 9.26884 14.0386 9.26884 15.119C9.26884 16.1559 8.48278 16.921 7.36922 16.921H5.99502V19.009H4.75647L4.75633 13.2598ZM0.5 11.4134V20.8521H2.21175V26.9804L22.7857 27V20.8526H24.5V11.4132L0.5 11.4134Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.99505 14.2538V15.9425L7.17263 15.9426C7.82843 15.9426 8.16018 15.6206 8.18076 15.0863C8.20313 14.4916 7.66809 14.2538 7.17263 14.2538L5.99505 14.2538Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4154 14.2538V15.9425H12.5926C13.2492 15.9425 13.5827 15.6205 13.6007 15.0862C13.624 14.4915 13.0889 14.2537 12.5926 14.2537L11.4154 14.2538Z"
      fill="currentcolor"
    />
  </svg>
</template>
